import i18n from '@/lang/i18n'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import {
    UserType,
    UserTypeTranslationKeys
} from '@/api/resources/common/initialization/common-initialization.dto.ts'
import { getEnumTranslationKeyColumnGridOptions } from '@/grid/base-grid-options'

export default function() {
    return [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.tc('configuration.grid.id'),
            field: 'id',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.username'),
            field: 'username',
            flex: 1
        },
        {
            ...getEnumTranslationKeyColumnGridOptions(
                UserTypeTranslationKeys,
                'code',
                'translationKey'
            ),
            headerName: i18n.tc('configuration.grid.userType'),
            type: AgGridColumnType.TEXT,
            colId: 'userType',
            field: 'userType.translationKey',
            minWidth: 190,
            flex: 1
        },
        {
            type: AgGridColumnType.DATETIME,
            headerName: i18n.tc('configuration.grid.lastAccessDate'),
            field: 'lastAccess',
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            filter: false,
            headerName: i18n.tc('configuration.grid.name'),
            sortable: false,
            cellRenderer: node => {
                switch (node.data.userType.enumValue) {
                case UserType.PERSONNEL:
                    return node.data.personnel.name
                case UserType.PETITIONER:
                    return node.data.petitioner.name
                case UserType.PATIENT:
                    return node.data.patient.name
                }
            },
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            filter: false,
            headerName: i18n.tc('configuration.grid.middleName'),
            sortable: false,
            colId: 'middleName',
            cellRenderer: node => {
                switch (node.data.userType.enumValue) {
                case UserType.PERSONNEL:
                    return node.data.personnel.middleName
                case UserType.PETITIONER:
                    return node.data.petitioner.middleName
                case UserType.PATIENT:
                    return node.data.patient.middleName
                }
            },
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            filter: false,
            headerName: i18n.tc('configuration.grid.surname1'),
            sortable: false,
            cellRenderer: node => {
                switch (node.data.userType.enumValue) {
                case UserType.PERSONNEL:
                    return node.data.personnel.surname1
                case UserType.PETITIONER:
                    return node.data.petitioner.surname1
                case UserType.PATIENT:
                    return node.data.patient.surname1
                }
            },
            flex: 1
        },
        {
            type: AgGridColumnType.TEXT,
            filter: false,
            headerName: i18n.tc('configuration.grid.surname2'),
            sortable: false,
            cellRenderer: node => {
                switch (node.data.userType.enumValue) {
                case UserType.PERSONNEL:
                    return node.data.personnel.surname2
                case UserType.PETITIONER:
                    return node.data.petitioner.surname2
                case UserType.PATIENT:
                    return node.data.patient.surname2
                }
            },
            flex: 1
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.blocked'),
            field: 'blocked',
            minWidth: 100,
            flex: 1
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            flex: 1
        }
    ]
}
